:host {
  display: block;
}
:host .option {
  padding-left: 16px;
  padding-right: 16px;
  color: var(--text-color);
  font-size: var(--font-size);
  font-family: var(--font-family);
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
:host .option:hover {
  transition: background-color 0.25s;
  background-color: var(--item-hover-color);
}
:host .option-selected {
  background-color: var(--item-active-color);
}
:host .option[disabled] {
  color: gray;
  cursor: default;
}
:host .option[disabled] ch-icon {
  filter: grayscale(100%);
}
:host .option[disabled]:hover {
  background-color: transparent;
}
:host .icon {
  display: inline-block;
  line-height: 0;
}
:host .left-icon {
  margin-inline-end: 8px;
}
:host .right-icon {
  margin-inline-start: 16px;
}
:host .left-container {
  display: flex;
  align-items: center;
}